import { LocationDetailsProvider } from '../providers/locationDetailsProvider';
import { AsyncAction } from '../../base-classes/asyncAction';

export const GET_LOCATION_DETAILS_BY_LATLON = new AsyncAction('GET_LOCATION_DETAILS_BY_LATLON');
export const GET_LOCATION_DETAILS_BY_SLUG = new AsyncAction('GET_LOCATION_DETAILS_BY_SLUG');
export const GET_LOCATION_DETAILS_BY_POSTALCODE = new AsyncAction('GET_LOCATION_DETAILS_BY_POSTALCODE');
export const GET_LOCATION_DETAILS_BY_CITYID = new AsyncAction('GET_LOCATION_DETAILS_BY_CITYID');

export function getLocationDetailsByLatLon(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    return {
        type: GET_LOCATION_DETAILS_BY_LATLON.base,
        payload: getLocationDetails(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh)
    };
}

async function getLocationDetails(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    const op = new LocationDetailsProvider(baseUrl, authId, secret);
    return await op.getLocationDetails(latitude, longitude, stdParameters, verbose, refresh);
}

export function getLocationDetailsBySlug(slug, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    return {
        type: GET_LOCATION_DETAILS_BY_SLUG.base,
        payload: getLocationDetailsBySlugName(slug, baseUrl, authId, secret, stdParameters, verbose, refresh)
    };
}

async function getLocationDetailsBySlugName(slug, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    const op = new LocationDetailsProvider(baseUrl, authId, secret);
    return await op.getLocationDetailsBySlugName(slug, stdParameters, verbose, refresh);
}

export function getLocationDetailsByPostalCode(postalCode, countryCode, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    return {
        type: GET_LOCATION_DETAILS_BY_POSTALCODE.base,
        payload: getLocationDetailsByPostCode(postalCode, countryCode, baseUrl, authId, secret, stdParameters, verbose, refresh)
    };
}

async function getLocationDetailsByPostCode(postalCode, countryCode, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    const op = new LocationDetailsProvider(baseUrl, authId, secret);
    return await op.getLocationDetailsByPostalCode(postalCode, countryCode, stdParameters, verbose, refresh);
}

export function getLocationDetailsByCityId(cityId, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    return {
        type: GET_LOCATION_DETAILS_BY_CITYID.base,
        payload: getLocationDetailsByCity(cityId, baseUrl, authId, secret, stdParameters, verbose, refresh)
    };
}

async function getLocationDetailsByCity(cityId, baseUrl, authId, secret, stdParameters, verbose, refresh) {
    const op = new LocationDetailsProvider(baseUrl, authId, secret);
    return await op.getLocationDetailsByCityId(cityId, stdParameters, verbose, refresh);
}
